export const HeadInfoColumns = [
  "head.title_before_name",
  "head.first_name",
  "head.last_name",
  "head.title_after_name",
  "head.role",
];
